import React from 'react';
import '../../styles/Boutique/Category.css';

const CategoryFilter = ({ selectedCategories, setSelectedCategories }) => {
  const categories = [
    'ACCESSOIRES VESTIMENTAIRES',
    'AUTOCOLLANTS CARTES POSTALES',
    'BANDESDESSINEES',
    'BIJOUX',
    'CD / DVD / CARNETS CHANTS',
    'COIFFURES',
    'COUTEAUX',
    'DIVERS',
    'INSIGNES ET PIN\'S',
    'LIVRES',
    'MAGNETS',
    'MONNAIE ET BILLET',
    'MUGS',
    'PARFUM',
    'POLOS - T-shirt',
    'PORTE-CLEFS',
    'STYLOS'
  ];

  const handleCategoryChange = (category) => {
    if (category === 'all') {
      setSelectedCategories([]);
    } else {
      setSelectedCategories(prev =>
        prev.includes(category)
          ? prev.filter(c => c !== category)
          : [...prev, category]
      );
    }
  };

  return (
    <div className="category-checkboxes">
      <label className="category-checkbox">
        <input
          type="checkbox"
          className="category-input"
          checked={selectedCategories.length === 0}
          onChange={() => handleCategoryChange('all')}
        />
        Toutes les catégories
      </label>
      {categories.map(category => (
        <label key={category} className="category-checkbox">
          <input
            type="checkbox"
            className="category-input"
            checked={selectedCategories.includes(category)}
            onChange={() => handleCategoryChange(category)}
          />
          {category}
        </label>
      ))}
    </div>
  );
};

export default CategoryFilter;
